/** Domain email nội bộ backend tự sinh khi Admin tạo user chỉ bằng username (không nhập email). */
const FAKE_EMAIL_DOMAIN = '@noemail.local';

export function isFakeEmail(email: string | null | undefined): boolean {
  return Boolean(email && email.toLowerCase().endsWith(FAKE_EMAIL_DOMAIN));
}

/**
 * Chuỗi hiển thị thay cho email ở UI — nếu email là email nội bộ tự sinh
 * (user không có email thật, chỉ có username), hiện "@username" thay vì lộ
 * domain giả noemail.local ra ngoài.
 */
export function displayIdentity(user: { email: string; username?: string | null }): string {
  if (isFakeEmail(user.email) && user.username) {
    return `@${user.username}`;
  }
  return user.email;
}
